import { useState } from 'react';

import { createTable } from '../plugins/table/tableUtils';
import DropDownButton from './DropDownButton';
import ToolbarDivider from './ToolbarDivider';

import Typography from '@mui/material/Typography';

import { faTable } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MAX_ROWS = 6;
const MAX_COLUMNS = 6;

function TableSizePicker({ onSelect }) {
  const [hovered, setHovered] = useState(null);

  return (
    <div css={pickerCss} onMouseLeave={() => setHovered(null)}>
      <div css={gridCss}>
        {[...Array(MAX_ROWS)].map((_, rowIndex) =>
          [...Array(MAX_COLUMNS)].map((__, columnIndex) => (
            <div
              key={`${rowIndex}-${columnIndex}`}
              className={
                hovered && rowIndex <= hovered.rowIndex && columnIndex <= hovered.columnIndex ?
                  'sizeCell sizeCell_selected'
                : 'sizeCell'
              }
              onMouseDown={() => onSelect(rowIndex + 1, columnIndex + 1)}
              onMouseEnter={() => setHovered({ columnIndex, rowIndex })}
            />
          )),
        )}
      </div>
      <Typography align="center" component="div" sx={{ color: 'text.secondary' }} variant="caption">
        {hovered ? `${hovered.rowIndex + 1} × ${hovered.columnIndex + 1}` : 'Insert table'}
      </Typography>
    </div>
  );
}

export default function TableControls({ nested, onAddAtomicBlock }) {
  if (nested) return null;

  return (
    <>
      <DropDownButton
        icon={
          <>
            <FontAwesomeIcon icon={faTable} />
            <FontAwesomeIcon icon={faCaretDown} size="xs" />
          </>
        }
        tooltip="table"
      >
        <TableSizePicker onSelect={(rows, columns) => onAddAtomicBlock('TABLE', createTable(rows, columns))} />
      </DropDownButton>
      <ToolbarDivider />
    </>
  );
}

const pickerCss = ({ spacing }) => ({ padding: spacing(1) });

const gridCss = ({ palette, spacing }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${MAX_COLUMNS}, 16px)`,
  gap: 2,
  marginBottom: spacing(0.5),

  '& .sizeCell': {
    height: 16,
    borderRadius: 2,
    cursor: 'pointer',
    border: `1px solid ${palette.divider}`,
  },
  '& .sizeCell_selected': {
    backgroundColor: palette.primary.background,
    borderColor: palette.primary.main,
  },
});
